import React, { useEffect, useState } from 'react';
import { Form, Button, Col, OverlayTrigger, Tooltip, FormGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { Send, Calendar, Info, Check, X } from 'lucide-react';
import Toaster from '../../Shared/Toaster/Toaster';
import NumberFormat from 'react-number-format';
import { userNameCheckApi } from "../../../commonservices/CommonAPICalls";
import { useSelector } from 'react-redux';
import ZipCodeInput from '../../Shared/helperComponents/zipcode.components';
import { convertToSSNFormat } from '../../../commonservices/CommonMethods';
import TextBox from "../../Shared/common/components/Shared_FormControls/TextBox/TextBox";
import Email from "../../Shared/common/components/Shared_FormControls/Email/Email";
import Phone from "../../Shared/common/components/Shared_FormControls/PhoneNumberField/PhoneNumberField";
import DatePicker from "../../Shared/common/components/Shared_FormControls/CustomisedReactDatePicker/CustomisedReactDatePicker";
import SSN from '../../Shared/common/components/Shared_FormControls/SSN/SSN';
import SelectBox from '../../Shared/common/components/Shared_FormControls/SelectBox/SelectBox';
import Number from '../../Shared/common/components/Shared_FormControls/Number/Number';
import Password from '../../Shared/common/components/Shared_FormControls/Password/Password';
import CustomCheckBox from '../../Shared/common/components/Shared_FormControls/CustomCheckBox/CustomCheckBox';

const DealerSignUpInfo = (props) => {

    const facilityAmount = [
        { label: 'Select Requested Amount', value: '' },
        { label: '$100,000', value: '100000' },
        { label: '$150,000', value: '150000' },
        { label: '$200,000', value: '200000' },
        { label: '$250,000', value: '250000' },
        { label: '$300,000', value: '300000' },
        { label: '$350,000', value: '350000' },
        { label: '$400,000', value: '400000' },
        { label: '$500,000', value: '500000' },
        { label: '$600,000', value: '600000' },
        { label: '$700,000', value: '700000' },
        { label: '$800,000', value: '800000' },
        { label: '$900,000', value: '900000' },
        { label: '$1,000,000', value: '1000000' },
        { label: '$1,500,000', value: '1500000' },
        { label: '$2,000,000', value: '2000000' },
        { label: '$2,500,000', value: '2500000' },
        { label: '$3,000,000', value: '3000000' },
        { label: '$4,000,000', value: '4000000' },
        { label: '$4 Million+', value: '4100000' }
    ]

    const storeData = useSelector((store) => store.sharedReducer)
    const [showPassword, setShowPassword] = useState(false);
    const [ssnValid, setSsnValid] = useState(true);
    const [phoneValid, setPhoneValid] = useState(true);
    const [stateValid, setStateValid] = useState(true);
    const [reqAmountValid, setReqAmountValid] = useState(true);
    const [dobValid, setdobValid] = useState(true);
    const [validated, setValidated] = useState(false);
    const [homeStateValid, setHomeStateValid] = useState(true);
    const [showCPError, setShowCPError] = useState(false);
    const [toaster, setToaster] = useState({
        header: '',
        class: '',
        content: '',
        showToaster: false
    });

    const [isFilledAtleastOnce, setIsFilledAtleastOnce] = useState(false);
    const [passwordCheck, setPasswordCheck] = useState({
        atleastSixteenChars: false,
        atleastOneUpperCase: false,
        atleastOneLowerCase: false,
        atleastOneNumber: false,
        atleastOneSpecial: false
    });
    const partnerName = localStorage.getItem('partnerName') ? localStorage.getItem('partnerName') : '';

    useEffect(() => {

        if (props.formData.password && !isFilledAtleastOnce)
            setIsFilledAtleastOnce(true);

        setPasswordCheck({
            atleastSixChars: /^.{6,}$/.test(props.formData.password),
            atleastOneUpperCase: /[A-Z]+/g.test(props.formData.password),
            atleastOneLowerCase: /[a-z]+/g.test(props.formData.password),
            atleastOneNumber: /\d/g.test(props.formData.password),
            atleastOneSpecial: /\W+/g.test(props.formData.password)
        })

    }, [props.formData.password])


    useEffect(() => {

        if (validated && props.formData.confirmPassword !== props.formData.password)
            setShowCPError(true);
        else if (validated && props.formData.confirmPassword === props.formData.password)
            setShowCPError(false);

    }, [props.formData.password, props.formData.confirmPassword])

    const toasterClose = () => {

        setToaster({
            header: '',
            class: '',
            content: '',
            showToaster: false
        })

    };

    const submit = (event) => {

        event.preventDefault();
        event.stopPropagation();
        setValidated(true);
        if (props.userNameCheck) return;

        let isCustomFieldsValid = true;
        const form = event.currentTarget;

        if (!props.formData.confirmPassword || props.formData.password !== props.formData.confirmPassword)
            setShowCPError(true);

        if (props.formData.phone && props.formData.phone.length === 10)
            setPhoneValid(true);
        else {
            setPhoneValid(false);
            isCustomFieldsValid = false;
        }

        if (props.formData.dealerDOB)
            setdobValid(true);
        else {
            setdobValid(false);
            isCustomFieldsValid = false;
        }

        if (props.formData.ssn && props.formData.ssn.length === 9)
            setSsnValid(true);
        else {
            setSsnValid(false);
            isCustomFieldsValid = false;
        }

        if (props.formData.dealerState)
            setStateValid(true);
        else {
            setStateValid(false);
            isCustomFieldsValid = false;
        }
        if (props.formData.requestedFacilityAmount)
            setReqAmountValid(true);
        else {
            setReqAmountValid(false);
            isCustomFieldsValid = false;
        }

        if (props.formData.homeState)
            setHomeStateValid(true);
        else {
            setHomeStateValid(false);
            isCustomFieldsValid = false;
        }


        if (form.checkValidity() !== false && isCustomFieldsValid) {

            if (props.formData.confirmPassword !== props.formData.password) {
                setShowCPError(true);
                return;

            }
            else if (!props.formData.confirmPassword) {
                setShowCPError(true);
                return;
            }
            else if (props.formData.confirmPassword === props.formData.password)
                setShowCPError(false);

            if (!props.formData.termsAndConditionsAccepted) {
                setToaster({
                    header: 'Error',
                    class: 'error-toaster',
                    content: 'Please accept the Terms and Conditions to continue.',
                    showToaster: true
                });
                return;
            }
            props.submit(event, null, null, true)
        }

    }

    useEffect(() => {

        if (validated && props.formData.phone && props.formData.phone.length === 10)
            setPhoneValid(true);
        else if (validated)
            setPhoneValid(false);

    }, [props.formData.phone]);

    useEffect(() => {

        if (validated && props.formData.ssn && props.formData.ssn.length === 9)
            setSsnValid(true);
        else if (validated)
            setSsnValid(false);

    }, [props.formData.ssn]);

    useEffect(() => {

        if (validated && props.formData.homeState)
            setHomeStateValid(true);
        else if (validated)
            setHomeStateValid(false);

    }, [props.formData.homeState]);

    useEffect(() => {

        if (validated && props.formData.dealerState)
            setStateValid(true);
        else if (validated)
            setStateValid(false);

    }, [props.formData.dealerState])

    useEffect(() => {

        if (validated && props.formData.requestedFacilityAmount)
            setReqAmountValid(true);
        else if (validated)
            setReqAmountValid(false);

    }, [props.formData.requestedFacilityAmount])

    useEffect(() => {

        if (validated && props.formData.dealerDOB)
            setdobValid(true);
        else if (validated)
            setdobValid(false);

    }, [props.formData.dealerDOB])

    useEffect(() => {

        const hasReloaded = localStorage.getItem('signupReloaded');
        
        if(!hasReloaded){
         localStorage.setItem('signupReloaded', true);
         window.location.reload(true);
        }
 
     }, [])
    return (
        <React.Fragment>
            {
                toaster.showToaster ?
                    <Toaster myClassName={toaster.class} onClose={toasterClose} header={toaster.header} content={toaster.content}></Toaster>
                    : null
            }
            <Form noValidate
                validated={validated}
                onSubmit={(event) => submit(event)}
                className="text-left from-wrapper dealerSignUpOnboarding">
                <div className='text-right text-xs-center mb-2'>
                    <small>Already registered? Please <Link to='/' className='blue-link-text' style={{ fontSize: '12px' }}>click here</Link> to sign in.</small>
                </div>
                <div className="onboarding-form-box-modal">
                    <h1>Dealer Principal:</h1>
                    <Form.Row className="align-items-start four-fields-row mx-0 dealer-principal-row">
                        <Form.Group as={Col} controlId="formGridStyle">
                            <TextBox
                                required
                                label="Dealer Principal First Name"
                                name="Dealer Principal First Name"
                                value={props.formData.firstName}
                                objectKey="firstName"
                                placeholder="First Name"
                                onChange={(key, value) => props.twoWayBind(key, value)}
                                onBlur={() => props.userNameChecking(props?.formData?.username)}
                            />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridStyle">
                            <TextBox
                                required
                                label="Dealer Principal Last Name"
                                name="Dealer Principal Last Name"
                                value={props.formData.lastName}
                                objectKey="lastName"
                                placeholder="Last Name"
                                onChange={(key, value) => props.twoWayBind(key, value)}
                                onBlur={() => props.userNameChecking(props?.formData?.username)}
                            />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridStyle">
                            <Email
                                required
                                label="Email Address"
                                name="Email"
                                objectKey="email"
                                placeholder="Email Address"
                                value={props.formData.email}
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridStyle">
                            <Phone
                                validated={!phoneValid}
                                infoMessage={props.formData.validationMessage === 'success' ? null : props.formData.validationMessage}
                                required
                                label="Cell Phone Number"
                                name="Phone Number"
                                objectKey="phone"
                                placeholder="(000) 000-0000"
                                value={props.formData.phone}
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridStyle">
                            <DatePicker
                                required
                                validated={!dobValid}
                                label="Dealer Principal DOB"
                                name="Dealer Principal DOB"
                                selected={props.formData.dealerDOB}
                                objectKey="dealerDOB"
                                placeholder="MM/DD/YYYY"
                                dateFormat="MM-dd-y"
                                value={props.formData.dealerDOB ? new Date(props.formData.dealerDOB) : null}
                                onChange={(key, value) => props.twoWayBind(key, value)}
                                autoPlacement="bottom"
                            />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridStyle">
                            <SSN
                                validated={!ssnValid}
                                required
                                label="Dealer Principal SSN"
                                name="Dealer Principal SSN"
                                objectKey="ssn"
                                placeholder="000-00-0000"
                                value={convertToSSNFormat(props.formData.ssn)}
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                            <small className='d-block'>We never do a hard credit pull</small>
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridStyle">
                            <TextBox
                                required
                                label="Dealership Address"
                                name="Dealership Address"
                                objectKey="homeAddressLine1"
                                placeholder="Street"
                                value={props.formData.homeAddressLine1}
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridStyle">
                            <TextBox
                                required
                                label="City"
                                name="city"
                                objectKey="homeCity"
                                placeholder="City"
                                value={props.formData.homeCity}
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridStyle">
                            <SelectBox
                                required
                                validated={!homeStateValid}
                                label="State"
                                options={storeData.masterData.states}
                                name="state"
                                objectKey="homeState"
                                placeholder="NY"
                                value={storeData.masterData.states && storeData.masterData.states.length > 0 && storeData.masterData.states.filter(item => item.value.toLowerCase() === props.formData.homeState.toLowerCase()).length ? storeData.masterData.states.filter(item => item.value.toLowerCase() === props.formData.homeState.toLowerCase())[0] : ''}
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                        </Form.Group>
                        <Form.Group className="w-127px" as={Col} controlId="formGridStyle">
                            <Number
                                required
                                label="Zip Code"
                                name="Zip Code"
                                allowLeadingZeros
                                objectKey="homeZipCode"
                                placeholder="Zip Code"
                                value={props.formData.homeZipCode}
                                format='#####'
                                onChange={(key, value) => props.twoWayBind(key, value)}
                                isZipCodeInput
                                validated={validated}
                            />
                        </Form.Group>
                    </Form.Row>
                </div>
                <div className="onboarding-form-box-modal">
                    <h6>Dealership Info</h6>
                    <Form.Row className="align-items-star four-fields-row mx-0 dealer-info-row">
                        <Form.Group as={Col} controlId="formGridStyle">
                            <TextBox
                                required
                                label="Dealership Name"
                                name="Dealership Name"
                                value={props.formData.dealerName}
                                objectKey="dealerName"
                                placeholder="Dealership Name"
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                        </Form.Group>
                        <Form.Group className="w-127px" as={Col} controlId="formGridStyle">
                            <SelectBox
                                required
                                validated={!reqAmountValid}
                                label="Requested Amount"
                                options={facilityAmount}
                                name="Requested Amount"
                                objectKey="requestedFacilityAmount"
                                placeholder="Requested Amount"
                                value={props.formData.requestedFacilityAmount}
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridStyle">
                            <TextBox
                                required
                                label="Dealership Address"
                                name="Dealership Address"
                                objectKey="dealerAddressLine1"
                                placeholder="Street"
                                value={props.formData.dealerAddressLine1}
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridStyle">
                            <TextBox
                                required
                                label="City"
                                name="city"
                                objectKey="dealerCity"
                                placeholder="City"
                                value={props.formData.dealerCity}
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridStyle">
                            <SelectBox
                                required
                                validated={!stateValid}
                                label="State"
                                options={storeData.masterData.states}
                                name="state"
                                objectKey="dealerState"
                                placeholder="NY"
                                value={props.formData.dealerState}
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridStyle">
                            <Number
                                required
                                label="Zip Code"
                                name="Zip Code"
                                allowLeadingZeros
                                objectKey="dealerZipCode"
                                placeholder="Zip Code"
                                value={props.formData.dealerZipCode}
                                format='#####'
                                onChange={(key, value) => props.twoWayBind(key, value)}
                                isZipCodeInput
                                validated={validated}
                            />
                        </Form.Group>
                    </Form.Row>
                </div>

                <div className="onboarding-form-box-modal">
                    <h6>Create Username and Password</h6>
                    <Form.Row className="align-items-start three-fields-row mx-0">
                        <Form.Group as={Col} controlId="formGridStyle" className='mb-0'>
                            <TextBox
                                required
                                label="User Name"
                                name="User Name"
                                value={props?.formData.username}
                                objectKey="username"
                                onBlur={() => props.userNameChecking(props?.formData.username)}
                                placeholder="User Name"
                                toLowerCase
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                        </Form.Group>
                        <Form.Group className="w-127px mb-0" as={Col} controlId="formGridStyle">
                            {!showPassword ?
                                <Password
                                    required
                                    label={
                                        <>
                                            <span>Create Password</span>
                                            <OverlayTrigger placement="bottom"
                                                overlay={
                                                    <Tooltip>Password must contain at least one uppercase, one lowercase, one digit, one special character and minimum of 6 characters.</Tooltip>}>
                                                <Info size={14} className='cursor-pointer' style={{ marginLeft: "5px" }} />
                                            </OverlayTrigger>
                                        </>
                                    }

                                    name='password'
                                    objectKey='password'
                                    value={props.formData.password}
                                    placeholder="Password"
                                    onChange={(key, value) => props.twoWayBind(key, value)}
                                />
                                : <Form.Group as={Col} className='px-0 mb-0' controlId="formGridStyle">
                                    <TextBox
                                        required
                                        label={
                                            <>
                                                <span>Create Password</span>
                                                <OverlayTrigger placement="bottom"
                                                    overlay={
                                                        <Tooltip>Password must contain at least one uppercase, one lowercase, one digit, one special character and minimum of 6 characters.</Tooltip>}>
                                                    <Info size={14} className='cursor-pointer' style={{ marginLeft: "5px" }} />
                                                </OverlayTrigger>
                                            </>
                                        }
                                        name="password"
                                        objectKey="password"
                                        placeholder="Password"
                                        value={props.formData.password}
                                        onChange={(key, value) => props.twoWayBind(key, value)}
                                    />
                                </Form.Group>}
                            {
                                isFilledAtleastOnce ?
                                    <div className='password-conditions mt-2 mb-0'>
                                        {passwordCheck.atleastSixChars ? <p style={{ color: '#0E8074' }}><span><Check size={18} /></span> At least 6 characters</p> : <p style={{ color: '#A10F0F' }}><span><X size={18} /></span> At least 6 characters</p>}
                                        {passwordCheck.atleastOneUpperCase ? <p style={{ color: '#0E8074' }}><span><Check size={18} /></span> At least one uppercase character</p> : <p style={{ color: '#A10F0F' }}><span><X size={18} /></span> At least one uppercase character</p>}
                                        {passwordCheck.atleastOneLowerCase ? <p style={{ color: '#0E8074' }}><span><Check size={18} /></span> At least one lowercase character</p> : <p style={{ color: '#A10F0F' }}><span><X size={18} /></span> At least one lowercase character</p>}
                                        {passwordCheck.atleastOneNumber ? <p style={{ color: '#0E8074' }}><span><Check size={18} /></span> At least one number</p> : <p style={{ color: '#A10F0F' }}><span><X size={18} /></span> At least one number</p>}
                                        {passwordCheck.atleastOneSpecial ? <p style={{ color: '#0E8074' }}><span><Check size={18} /></span> At least one special character</p> : <p style={{ color: '#A10F0F' }}><span><X size={18} /></span> At least one special character</p>}
                                    </div> : null
                            }
                        </Form.Group>
                        {!showPassword ?
                            <Form.Group className="w-127px mb-0" as={Col} controlId="formGridStyle">
                                <Password
                                    required
                                    label="Confirm Password"
                                    name='Confirm Password'
                                    objectKey='confirmPassword'
                                    placeholder="Confirm Password"
                                    value={props.formData.confirmPassword}
                                    onChange={(key, value) => props.twoWayBind(key, value)}
                                />
                                {showCPError ? <span className='customErrorText' style={{ fontSize: '12px', color: '#A10F0F', marginTop: '0.25rem', fontWeight: '500' }}>{props.formData.confirmPassword ? "Passwords Doesn't match." : ""}</span> : null}
                            </Form.Group> :
                            <Form.Group className="mb-0" as={Col} controlId="formGridStyle">
                                <TextBox
                                    required
                                    label="Confirm Password"
                                    name="Confirm Password"
                                    objectKey="confirmPassword"
                                    placeholder="Confirm Password"
                                    value={props.formData.confirmPassword}
                                    onChange={(key, value) => props.twoWayBind(key, value)}
                                />
                                {showCPError ? <span className='customErrorText' style={{ fontSize: '80%', color: '#A10F0F', marginTop: '0.25rem' }}>{props.formData.confirmPassword ? "Passwords Doesn't match." : ""}</span> : null}
                            </Form.Group>}


                    </Form.Row>
                    <Form.Row className="align-items-start mx-0 pt-3">
                        {showPassword ?
                            <Form.Group as={Col} className="mb-0" controlId="formGridStyle p-0">
                                <CustomCheckBox
                                    label="Show Password"
                                    onChange={() => setShowPassword(false)} />
                            </Form.Group> :
                            <Form.Group as={Col} className="mb-0" controlId="formGridStyle">
                                <CustomCheckBox
                                    label="Show Password"
                                    onChange={() => setShowPassword(true)} />
                            </Form.Group>}
                    </Form.Row>
                </div>


                <Form.Row className='mx-0'>
                    <Form.Group className="mb-3 content-text-10px onboarding-terms-checkbox label-color" controlId="formBasicCheckbox">
                        {props.formData.termsAndConditionsAccepted ?
                            // <Form.Check checked onChange={(event) => props.twoWayBind('termsAndConditionsAccepted', event.target.checked)} className='content-text-10px' type="checkbox" label={`I hereby certify that all of the information is true and accurate, to the best of my knowledge, and authorize ${partnerName} to perform all necessary verifications including, but not limited to, business and personal background checks, credit history, bond and insurance verifications, and authorize ${partnerName} and its parent company (Vero Technologies) to contact, verify and obtain any information as needed.`} />
                            <CustomCheckBox
                                objectKey='termsAndConditionsAccepted'
                                onChange={(key, checked, value) => props.twoWayBind(key, checked)}
                                label={`I hereby certify that all of the information is true and accurate, to the best of my knowledge, and authorize ${partnerName} to perform all necessary verifications including, but not limited to, business and personal background checks, credit history, bond and insurance verifications, and authorize ${partnerName} and its parent company (Vero Technologies) to contact, verify and obtain any information as needed.`}
                            />
                            :
                            // <Form.Check onChange={(event) => props.twoWayBind('termsAndConditionsAccepted', event.target.checked)} className='content-text-10px' type="checkbox" label={`I hereby certify that all of the information is true and accurate, to the best of my knowledge, and authorize ${partnerName} to perform all necessary verifications including, but not limited to, business and personal background checks, credit history, bond and insurance verifications, and authorize ${partnerName} and its parent company (Vero Technologies) to contact, verify and obtain any information as needed.`} />}
                            <CustomCheckBox
                                objectKey='termsAndConditionsAccepted'
                                onChange={(key, checked, value) => props.twoWayBind(key, checked)}
                                label={`I hereby certify that all of the information is true and accurate, to the best of my knowledge, and authorize ${partnerName} to perform all necessary verifications including, but not limited to, business and personal background checks, credit history, bond and insurance verifications, and authorize ${partnerName} and its parent company (Vero Technologies) to contact, verify and obtain any information as needed.`}
                            />
                        }
                    </Form.Group>
                </Form.Row>
                <Form.Row className='mx-0'>
                    <Button className="default-btn" type="submit" variant="primary">Submit</Button>
                </Form.Row>

            </Form>
        </React.Fragment>
    );

}


export default DealerSignUpInfo;